import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { termsUrl } from '../../../utils/utils';
import AppVersion from "Components/Common/AppVersion";

export const StyledFooter = styled('div')({
    position: 'fixed',
    width: '100%',
    bottom: '3%',
});

export const TermsAndPoliciesFooter = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <StyledFooter>
            <Typography
                variant="body2"
                align="center"
                style={{ color: '#999999' }}
            >
                {t('General.TermsAndPolicies.Footer.Label')} 
                <a href={termsUrl} target="_blank" rel="noreferrer">
                    {t('CommonWords.SoftwareTermsConditions')}
                </a>
                {', '}
                <AppVersion styled={false} />
            </Typography>
        </StyledFooter>
    );
};

export default TermsAndPoliciesFooter;
